module.exports = __webpack_public_path__ + "img/nr.43db7339.svg";